import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';

const initialState = {
  loading: false,
  data: [],
  feeForecast: [],
  forecastConfig: [],
  logs: [],
  crmList: [],
  manualForecast: [],
};

export const getFeeForecastData = createAsyncThunk('feeForecast/getFeeForecastData', async (data, action) => {
  const res = await apiRequest({
    url: `fee-forecast/admission-register?page=${data.page}&limit=${data.limit}&date=${data.date}&search=${data.search}&sortKey=${data.sortKey}&sortDir=${data.sortDir}&project=${data.project}&crm=${data.crm}&cro=${data.cro}&forecast_typeName=${data.forecast_typeName}&final_source=${data.final_source}&currency_type=${data.currency_type}&threshold=${data.threshold}&hardRefresh=${data.hardRefresh}`,
    method: 'get',
  });
  if (data.limit == 'no') {
    return action.rejectWithValue(res);
  }
  return res;
});

export const addExpectedSessions = createAsyncThunk('feeForecast/addExpectedSessions', async (data) => {
  const res = await apiRequest({
    url: `fee-forecast/expected-sessions`,
    method: 'post',
    data: data,
  });
  return res;
});

export const getForecastConfig = createAsyncThunk('feeForecast/getForecastConfig', async () => {
  const res = await apiRequest({
    url: `fee-forecast/config`,
    method: 'get',
  });
  return res;
});

export const updateForecastConfig = createAsyncThunk('feeForecast/updateForecastConfig', async (data) => {
  const res = await apiRequest({
    url: `fee-forecast/config`,
    method: 'post',
    data: data,
  });
  return res;
});

export const getLogs = createAsyncThunk('feeForecast/getLogs', async (data) => {
  const res = await apiRequest({
    url: `fee-forecast/fee-logs?year=${data.year}&month=${data.month}&page=${data.page}&limit=${data.limit}&search=${data.search}&sortDir=${data.sortDir}&sortKey=${data.sortKey}&project=${data.project}`,
    method: 'get',
  });
  return res;
});

export const addLogs = createAsyncThunk('feeForecast/addLogs', async (data) => {
  const res = await apiRequest({
    url: `fee-forecast/fee-logs`,
    method: 'post',
    data: data,
  });
  return res;
});

export const getCrms = createAsyncThunk('feeForecast/getCrms', async (projectId) => {
  const res = await apiRequest({
    url: `fee-forecast/crms?projectId=${projectId}`,
    method: 'get',
  });
  return res;
});

export const getManualForecast = createAsyncThunk('feeForecast/getManualForecast', async (projectId) => {
  const res = await apiRequest({
    url: `fee-forecast/manual-forecast`,
    method: 'get',
  });
  return res;
});

export const bulkUpload = createAsyncThunk('feeForecast/bulkUpload', async (data) => {
  const res = await apiRequest({
    url: `fee-forecast/manual-forecast`,
    method: 'post',
    data: data,
  });
  return res;
});

const feeForecastSlice = createSlice({
  name: 'feeForecastSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //.................createCartItem..............................
    builder.addCase(getFeeForecastData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getFeeForecastData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        feeForecast: action.payload,
      };
    });
    builder.addCase(getFeeForecastData.rejected, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------addExpectedSessions-----------------------------------
    builder.addCase(addExpectedSessions.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(addExpectedSessions.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // --------------getForecastConfig--------------------------------------

    builder.addCase(getForecastConfig.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getForecastConfig.fulfilled, (state, action) => {
      return {
        ...state,
        forecastConfig: action.payload.data,
        loading: false,
      };
    });
    // -----------------updateForecastConfig------------------------

    builder.addCase(updateForecastConfig.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateForecastConfig.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------getLogs----------------------------------

    builder.addCase(getLogs.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLogs.fulfilled, (state, action) => {
      return {
        ...state,
        logs: action.payload,
        loading: false,
      };
    });
    // -----------------addLogs-------------------------------
    builder.addCase(addLogs.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(addLogs.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------getCrms---------------------------------

    builder.addCase(getCrms.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCrms.fulfilled, (state, action) => {
      return {
        ...state,
        crmList: action.payload.data,
        loading: false,
      };
    });

    // --------------getManualForecast---------------------------
    builder.addCase(getManualForecast.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getManualForecast.fulfilled, (state, action) => {
      return {
        ...state,
        manualForecast: action.payload.data,
        loading: false,
      };
    });
    // -------------------bulkUpload----------------------------
    builder.addCase(bulkUpload.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(bulkUpload.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export default feeForecastSlice.reducer;
